import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import querystring from "querystring";
import { loginFromMedproId } from "~/store/user/userAction";
import { client } from "~/utils/medproSDK";
import axios from "axios";

class AuthorizedPage extends React.Component {
  constructor(props) {
    super(props);
    const { IsAuthenticated, history } = this.props;
    if (!IsAuthenticated) {
      console.log("window.location.pathname: ", window.location.pathname);
      const params = window.location.pathname.split("/")[3];
      const parse = querystring.parse(params);

      client.setToken(parse.token);
      axios.defaults.headers.Authorization = `Bearer ${parse.token}`;
      window.localStorage.setItem("jwt", parse.token);

      this.props.loginFromMedproId(parse);

      history.push(localStorage.getItem("loginAt") || "/");
    } else {
      history.push("/");
    }
  }

  componentDidUpdate(prevProps) {
    const { history, IsAuthenticated, currentUrl } = this.props;
    const loginAt = window.localStorage.getItem("loginAt") || "/";

    if (IsAuthenticated && !prevProps.IsAuthenticated) {
      history.push(loginAt || currentUrl);
    } else {
      history.push("/");
    }
  }

  render() {
    return <div>{}</div>;
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated },
    login: { currentUrl }
  } = state;
  return {
    IsAuthenticated,
    currentUrl
  };
};

export default connect(mapStateToProps, { loginFromMedproId })(
  withRouter(AuthorizedPage)
);
